import { DateTime } from 'luxon'

const toDeadlineMillis = (deadline?: string | null): number | null => {
  if (!deadline?.trim()) return null
  const parsed = DateTime.fromISO(deadline.trim())
  return parsed.isValid ? parsed.toMillis() : null
}

export const sortByAvailability = <T>(
  items: T[],
  isClosed: (item: T) => boolean,
  getDeadline?: (item: T) => string | null | undefined
): T[] => {
  return [...items].sort((a, b) => {
    const aClosed = isClosed(a) ? 1 : 0
    const bClosed = isClosed(b) ? 1 : 0
    if (aClosed !== bClosed) return aClosed - bClosed

    if (!getDeadline) return 0

    const aDeadline = toDeadlineMillis(getDeadline(a))
    const bDeadline = toDeadlineMillis(getDeadline(b))

    if (aDeadline == null && bDeadline == null) return 0
    if (aDeadline == null) return 1
    if (bDeadline == null) return -1

    return aDeadline - bDeadline
  })
}
